import * as React from "react";
import FormSelect from "./FormSelect";

const data = [
  {
    value: 'Россия',
    key: 'RUS',
  },
  {
    value: 'Абхазия',
    key: 'ABH',
  },
  {
    value: 'Австралия',
    key: 'AUS',
  },
  {
    value: 'Австрия',
    key: 'AUT',
  },
  {
    value: 'Азербайджан',
    key: 'AZE',
  },
  {
    value: 'Албания',
    key: 'ALB',
  },
  {
    value: 'Алжир',
    key: 'DZA',
  },
  {
    value: 'Американское Самоа',
    key: 'ASM',
  },
  {
    value: 'Ангилья',
    key: 'AIA',
  },
  {
    value: 'Ангола',
    key: 'AGO',
  },
  {
    value: 'Андорра',
    key: 'AND',
  },
  {
    value: 'Антарктида',
    key: 'ATA',
  },
  {
    value: 'Антигуа и Барбуда',
    key: 'ATG',
  },
  {
    value: 'Аргентина',
    key: 'ARG',
  },
  {
    value: 'Армения',
    key: 'ARM',
  },
  {
    value: 'Аруба',
    key: 'ABW',
  },
  {
    value: 'Афганистан',
    key: 'AFG',
  },
  {
    value: 'Багамы',
    key: 'BHS',
  },
  {
    value: 'Бангладеш',
    key: 'BGD',
  },
  {
    value: 'Барбадос',
    key: 'BRB',
  },
  {
    value: 'Бахрейн',
    key: 'BHR',
  },
  {
    value: 'Беларусь',
    key: 'BLR',
  },
  {
    value: 'Белиз',
    key: 'BLZ',
  },
  {
    value: 'Бельгия',
    key: 'BEL',
  },
  {
    value: 'Бенин',
    key: 'BEN',
  },
  {
    value: 'Бермуды',
    key: 'BMU',
  },
  {
    value: 'Болгария',
    key: 'BGR',
  },
  {
    value: 'Боливия, многонациональное государство',
    key: 'BOL',
  },
  {
    value: 'Бонэйр, Синт-Эстатиус и Саба',
    key: 'BES',
  },
  {
    value: 'Босния и Герцеговина',
    key: 'BIH',
  },
  {
    value: 'Ботсвана',
    key: 'BWA',
  },
  {
    value: 'Бразилия',
    key: 'BRA',
  },
  {
    value: 'Британская территория в Индийском океане',
    key: 'IOT',
  },
  {
    value: 'Бруней-Даруссалам',
    key: 'BRN',
  },
  {
    value: 'Буркина-Фасо',
    key: 'BFA',
  },
  {
    value: 'Бурунди',
    key: 'BDI',
  },
  {
    value: 'Бутан',
    key: 'BTN',
  },
  {
    value: 'Вануату',
    key: 'VUT',
  },
  {
    value: 'Венгрия',
    key: 'HUN',
  },
  {
    value: 'Венесуэла, Боливарианская Республика',
    key: 'VEN',
  },
  {
    value: 'Виргинские Острова, Британские',
    key: 'VGB',
  },
  {
    value: 'Виргинские Острова, США',
    key: 'VIR',
  },
  {
    value: 'Вьетнам',
    key: 'VNM',
  },
  {
    value: 'Габон',
    key: 'GAB',
  },
  {
    value: 'Гаити',
    key: 'HTI',
  },
  {
    value: 'Гайана',
    key: 'GUY',
  },
  {
    value: 'Гамбия',
    key: 'GMB',
  },
  {
    value: 'Гана',
    key: 'GHA',
  },
  {
    value: 'Гваделупа',
    key: 'GLP',
  },
  {
    value: 'Гватемала',
    key: 'GTM',
  },
  {
    value: 'Гвинея',
    key: 'GIN',
  },
  {
    value: 'Гвинея-Бисау',
    key: 'GNB',
  },
  {
    value: 'Германия',
    key: 'DEU',
  },
  {
    value: 'Гернси',
    key: 'GGY',
  },
  {
    value: 'Гибралтар',
    key: 'GIB',
  },
  {
    value: 'Гондурас',
    key: 'HND',
  },
  {
    value: 'Гонконг',
    key: 'HKG',
  },
  {
    value: 'Гренада',
    key: 'GRD',
  },
  {
    value: 'Гренландия',
    key: 'GRL',
  },
  {
    value: 'Греция',
    key: 'GRC',
  },
  {
    value: 'Грузия',
    key: 'GEO',
  },
  {
    value: 'Гуам',
    key: 'GUM',
  },
  {
    value: 'Дания',
    key: 'DNK',
  },
  {
    value: 'Джерси',
    key: 'JEY',
  },
  {
    value: 'Джибути',
    key: 'DJI',
  },
  {
    value: 'Доминика',
    key: 'DMA',
  },
  {
    value: 'Доминиканская Республика',
    key: 'DOM',
  },
  {
    value: 'Египет',
    key: 'EGY',
  },
  {
    value: 'Замбия',
    key: 'ZMB',
  },
  {
    value: 'Западная Сахара',
    key: 'ESH',
  },
  {
    value: 'Зимбабве',
    key: 'ZWE',
  },
  {
    value: 'Израиль',
    key: 'ISR',
  },
  {
    value: 'Индия',
    key: 'IND',
  },
  {
    value: 'Индонезия',
    key: 'IDN',
  },
  {
    value: 'Иордания',
    key: 'JOR',
  },
  {
    value: 'Ирак',
    key: 'IRQ',
  },
  {
    value: 'Иран, Исламская Республика',
    key: 'IRN',
  },
  {
    value: 'Ирландия',
    key: 'IRL',
  },
  {
    value: 'Исландия',
    key: 'ISL',
  },
  {
    value: 'Испания',
    key: 'ESP',
  },
  {
    value: 'Италия',
    key: 'ITA',
  },
  {
    value: 'Йемен',
    key: 'YEM',
  },
  {
    value: 'Кабо-Верде',
    key: 'CPV',
  },
  {
    value: 'Казахстан',
    key: 'KAZ',
  },
  {
    value: 'Камбоджа',
    key: 'KHM',
  },
  {
    value: 'Камерун',
    key: 'CMR',
  },
  {
    value: 'Канада',
    key: 'CAN',
  },
  {
    value: 'Катар',
    key: 'QAT',
  },
  {
    value: 'Кения',
    key: 'KEN',
  },
  {
    value: 'Кипр',
    key: 'CYP',
  },
  {
    value: 'Киргизия',
    key: 'KGZ',
  },
  {
    value: 'Кирибати',
    key: 'KIR',
  },
  {
    value: 'Китай',
    key: 'CHN',
  },
  {
    value: 'Кокосовые (Килинг) острова',
    key: 'CCK',
  },
  {
    value: 'Колумбия',
    key: 'COL',
  },
  {
    value: 'Коморы',
    key: 'COM',
  },
  {
    value: 'Конго',
    key: 'COG',
  },
  {
    value: 'Конго, Демократическая Республика',
    key: 'COD',
  },
  {
    value: 'Корея, Народно-Демократическая Республика',
    key: 'PRK',
  },
  {
    value: 'Корея, Республика',
    key: 'KOR',
  },
  {
    value: 'Коста-рика',
    key: 'CRI',
  },
  {
    value: 'Кот д`Ивуар',
    key: 'CIV',
  },
  {
    value: 'Куба',
    key: 'CUB',
  },
  {
    value: 'Кувейт',
    key: 'KWT',
  },
  {
    value: 'Кюрасао',
    key: 'CUW',
  },
  {
    value: 'Лаосская Народно-Демократическая Республика',
    key: 'LAO',
  },
  {
    value: 'Латвия',
    key: 'LVA',
  },
  {
    value: 'Лесото',
    key: 'LSO',
  },
  {
    value: 'Либерия',
    key: 'LBR',
  },
  {
    value: 'Ливан',
    key: 'LBN',
  },
  {
    value: 'Ливия',
    key: 'LBY',
  },
  {
    value: 'Литва',
    key: 'LTU',
  },
  {
    value: 'Лихтенштейн',
    key: 'LIE',
  },
  {
    value: 'Люксембург',
    key: 'LUX',
  },
  {
    value: 'Маврикий',
    key: 'MUS',
  },
  {
    value: 'Мавритания',
    key: 'MRT',
  },
  {
    value: 'Мадагаскар',
    key: 'MDG',
  },
  {
    value: 'Майотта',
    key: 'MYT',
  },
  {
    value: 'Макао',
    key: 'MAC',
  },
  {
    value: 'Малави',
    key: 'MWI',
  },
  {
    value: 'Малайзия',
    key: 'MYS',
  },
  {
    value: 'Мали',
    key: 'MLI',
  },
  {
    value: 'Малые Тихоокеанские Отдаленные острова Соединенных Штатов',
    key: 'UMI',
  },
  {
    value: 'Мальдивы',
    key: 'MDV',
  },
  {
    value: 'Мальта',
    key: 'MLT',
  },
  {
    value: 'Марокко',
    key: 'MAR',
  },
  {
    value: 'Мартиника',
    key: 'MTQ',
  },
  {
    value: 'Маршалловы Острова',
    key: 'MHL',
  },
  {
    value: 'Мексика',
    key: 'MEX',
  },
  {
    value: 'Микронезия, Федеративные Штаты',
    key: 'FSM',
  },
  {
    value: 'Мозамбик',
    key: 'MOZ',
  },
  {
    value: 'Молдова, Республика',
    key: 'MDA',
  },
  {
    value: 'Монако',
    key: 'MCO',
  },
  {
    value: 'Монголия',
    key: 'MNG',
  },
  {
    value: 'Монтсеррат',
    key: 'MSR',
  },
  {
    value: 'Мьянма',
    key: 'MMR',
  },
  {
    value: 'Намибия',
    key: 'NAM',
  },
  {
    value: 'Науру',
    key: 'NRU',
  },
  {
    value: 'Непал',
    key: 'NPL',
  },
  {
    value: 'Нигер',
    key: 'NER',
  },
  {
    value: 'Нигерия',
    key: 'NGA',
  },
  {
    value: 'Нидерланды',
    key: 'NLD',
  },
  {
    value: 'Никарагуа',
    key: 'NIC',
  },
  {
    value: 'Ниуэ',
    key: 'NIU',
  },
  {
    value: 'Новая Зеландия',
    key: 'NZL',
  },
  {
    value: 'Новая Каледония',
    key: 'NCL',
  },
  {
    value: 'Норвегия',
    key: 'NOR',
  },
  {
    value: 'Объединенные Арабские Эмираты',
    key: 'ARE',
  },
  {
    value: 'Оман',
    key: 'OMN',
  },
  {
    value: 'Остров Буве',
    key: 'BVT',
  },
  {
    value: 'Остров Мэн',
    key: 'IMN',
  },
  {
    value: 'Остров Норфолк',
    key: 'NFK',
  },
  {
    value: 'Остров Рождества',
    key: 'CXR',
  },
  {
    value: 'Остров Херд и острова Макдональд',
    key: 'HMD',
  },
  {
    value: 'Острова Кайман',
    key: 'CYM',
  },
  {
    value: 'Острова Кука',
    key: 'COK',
  },
  {
    value: 'Острова Теркс и Кайкос',
    key: 'TCA',
  },
  {
    value: 'Пакистан',
    key: 'PAK',
  },
  {
    value: 'Палау',
    key: 'PLW',
  },
  {
    value: 'Палестина, Государство',
    key: 'PSE',
  },
  {
    value: 'Панама',
    key: 'PAN',
  },
  {
    value: 'Папский Престол (Государство-город Ватикан)',
    key: 'VAT',
  },
  {
    value: 'Папуа Новая Гвинея',
    key: 'PNG',
  },
  {
    value: 'Парагвай',
    key: 'PRY',
  },
  {
    value: 'Перу',
    key: 'PER',
  },
  {
    value: 'Питкерн',
    key: 'PCN',
  },
  {
    value: 'Польша',
    key: 'POL',
  },
  {
    value: 'Португалия',
    key: 'PRT',
  },
  {
    value: 'Пуэрто-Рико',
    key: 'PRI',
  },
  {
    value: 'Республика Македония',
    key: 'MKD',
  },
  {
    value: 'Реюньон',
    key: 'REU',
  },
  {
    value: 'Руанда',
    key: 'RWA',
  },
  {
    value: 'Румыния',
    key: 'ROU',
  },
  {
    value: 'Самоа',
    key: 'WSM',
  },
  {
    value: 'Сан-Марино',
    key: 'SMR',
  },
  {
    value: 'Сан-Томе и Принсипи',
    key: 'STP',
  },
  {
    value: 'Саудовская Аравия',
    key: 'SAU',
  },
  {
    value: 'Свазиленд',
    key: 'SWZ',
  },
  {
    value: 'Святая Елена, Остров Вознесения, Тристан-да-Кунья',
    key: 'SHN',
  },
  {
    value: 'Северные Марианские Острова',
    key: 'MNP',
  },
  {
    value: 'Сейшелы',
    key: 'SYC',
  },
  {
    value: 'Сен-Бартелеми',
    key: 'BLM',
  },
  {
    value: 'Сен-Мартен',
    key: 'MAF',
  },
  {
    value: 'Сен-Мартен (нидерландская часть)',
    key: 'SXM',
  },
  {
    value: 'Сенегал',
    key: 'SEN',
  },
  {
    value: 'Сент-Винсент и Гренадины',
    key: 'VCT',
  },
  {
    value: 'Сент-Китс и Невис',
    key: 'KNA',
  },
  {
    value: 'Сент-Люсия',
    key: 'LCA',
  },
  {
    value: 'Сент-Пьер и Микелон',
    key: 'SPM',
  },
  {
    value: 'Сербия',
    key: 'SRB',
  },
  {
    value: 'Сингапур',
    key: 'SGP',
  },
  {
    value: 'Сирийская Арабская Республика',
    key: 'SYR',
  },
  {
    value: 'Словакия',
    key: 'SVK',
  },
  {
    value: 'Словения',
    key: 'SVN',
  },
  {
    value: 'Соединенное Королевство',
    key: 'GBR',
  },
  {
    value: 'Соединенные Штаты',
    key: 'USA',
  },
  {
    value: 'Соломоновы Острова',
    key: 'SLB',
  },
  {
    value: 'Сомали',
    key: 'SOM',
  },
  {
    value: 'Судан',
    key: 'SDN',
  },
  {
    value: 'Суринам',
    key: 'SUR',
  },
  {
    value: 'Сьерра-Леоне',
    key: 'SLE',
  },
  {
    value: 'Таджикистан',
    key: 'TJK',
  },
  {
    value: 'Таиланд',
    key: 'THA',
  },
  {
    value: 'Тайвань (Китай)',
    key: 'TWN',
  },
  {
    value: 'Танзания, Объединенная Республика',
    key: 'TZA',
  },
  {
    value: 'Тимор-Лесте',
    key: 'TLS',
  },
  {
    value: 'Того',
    key: 'TGO',
  },
  {
    value: 'Токелау',
    key: 'TKL',
  },
  {
    value: 'Тонга',
    key: 'TON',
  },
  {
    value: 'Тринидад и Тобаго',
    key: 'TTO',
  },
  {
    value: 'Тувалу',
    key: 'TUV',
  },
  {
    value: 'Тунис',
    key: 'TUN',
  },
  {
    value: 'Туркмения',
    key: 'TKM',
  },
  {
    value: 'Турция',
    key: 'TUR',
  },
  {
    value: 'Уганда',
    key: 'UGA',
  },
  {
    value: 'Узбекистан',
    key: 'UZB',
  },
  {
    value: 'Украина',
    key: 'UKR',
  },
  {
    value: 'Уоллис и Футуна',
    key: 'WLF',
  },
  {
    value: 'Уругвай',
    key: 'URY',
  },
  {
    value: 'Фарерские Острова',
    key: 'FRO',
  },
  {
    value: 'Фиджи',
    key: 'FJI',
  },
  {
    value: 'Филиппины',
    key: 'PHL',
  },
  {
    value: 'Финляндия',
    key: 'FIN',
  },
  {
    value: 'Фолклендские Острова (Мальвинские)',
    key: 'FLK',
  },
  {
    value: 'Франция',
    key: 'FRA',
  },
  {
    value: 'Французская Гвиана',
    key: 'GUF',
  },
  {
    value: 'Французская Полинезия',
    key: 'PYF',
  },
  {
    value: 'Французские Южные территории',
    key: 'ATF',
  },
  {
    value: 'Хорватия',
    key: 'HRV',
  },
  {
    value: 'Центрально-Африканская Республика',
    key: 'CAF',
  },
  {
    value: 'Чад',
    key: 'TCD',
  },
  {
    value: 'Черногория',
    key: 'MNE',
  },
  {
    value: 'Чешская Республика',
    key: 'CZE',
  },
  {
    value: 'Чили',
    key: 'CHL',
  },
  {
    value: 'Швейцария',
    key: 'CHE',
  },
  {
    value: 'Швеция',
    key: 'SWE',
  },
  {
    value: 'Шпицберген и Ян Майен',
    key: 'SJM',
  },
  {
    value: 'Шри-Ланка',
    key: 'LKA',
  },
  {
    value: 'Эквадор',
    key: 'ECU',
  },
  {
    value: 'Экваториальная Гвинея',
    key: 'GNQ',
  },
  {
    value: 'Эландские Острова',
    key: 'ALA',
  },
  {
    value: 'Эль-Сальвадор',
    key: 'SLV',
  },
  {
    value: 'Эритрея',
    key: 'ERI',
  },
  {
    value: 'Эстония',
    key: 'EST',
  },
  {
    value: 'Эфиопия',
    key: 'ETH',
  },
  {
    value: 'Южная Африка',
    key: 'ZAF',
  },
  {
    value: 'Южная Джорджия и Южные Сандвичевы Острова',
    key: 'SGS',
  },
  {
    value: 'Южная Осетия',
    key: 'OST',
  },
  {
    value: 'Южный Судан',
    key: 'SSD',
  },
  {
    value: 'Ямайка',
    key: 'JAM',
  },
  {
    value: 'Япония',
    key: 'JPN',
  },
];


export function FormSelectCountryAlpha3Codes({onChange, name, required, value, label}) {
  return (
    <FormSelect data={data}
                label={label || ''}
                required={required}
                value={value ? value : ''}
                onChange={onChange ? onChange : void 0}
                name={name}/>
  )
}